module.exports = __webpack_public_path__ + "img/onekey__vrbo.5b107394.svg";